<div class="tab-content">
    <div role="tabpanel" class="center-75per-width" id="users">
        <section>
            <div class="clearfix">
                <div class="col-md-6 no-padding">
                    <div class="row">
                        <div class="col-md-6">
                            <select tabindex="0" id="autofocus-element" autofocus
                                class="form-control ng-pristine  ng-touched" [(ngModel)]="operatingCountry">
                                <option *ngIf="isCountriesLoading" [value]="0">Loading...</option>
                                <option [value]="0">{{'config-system.Operating Country' |translate}}</option>
                                <option *ngFor="let country of operatingCountries | orderBy:'name'"
                                    [value]="country.id">{{country.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-6 floating-input floatLabelContainer">
                            <input tabindex="0" type="text" float-label class="form-control" [(ngModel)]="orderReason"
                                placeholder="{{'config-system.Cancel/Refund Reason Name' |translate |translateKey}}"
                                (keyup.enter)="onSearch()" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6  right-padding-0">
                    <button class="btn blue-button" tabindex="0" type="submit" (click)="onSearch()"
                        id="search-button">{{'config-system.Search' |translate |translateKey}}</button>
                    <button class="btn grey-button" tabindex="0" type="button"
                        (click)="clearFields()">{{'config-system.Clear' |translate |translateKey}}</button>
                </div>
                <div class="clearfix text-left col-md-12 no-padding">
                    <a autofocus="" tabindex="0" id="processor-btn" (click)="openCreateReasonModal()">
                        <span class="glyphicon glyphicon-plus"></span>
                        &nbsp;&nbsp;&nbsp;{{'config-system.ADD NEW' |translate |translateKey}}
                    </a>
                </div>
            </div>

            <!-- table starts -->
            <div class=" clearfix">
                <table class="table table-hover table-striped custab">
                    <thead>
                        <tr>
                            <th (click)="sortTableByColumn('reasonNote')" class="pointer">
                                {{'config-system.Reason' |translate |translateKey}}&nbsp;
                                <i class="fa"
                                    [ngClass]="{'fa-sort': sortColumn != 'reasonNote', 'fa-sort-asc': (sortColumn == 'reasonNote' && isDesc), 'fa-sort-desc': (sortColumn == 'reasonNote' && !isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                            <th>{{'config-system.Operating Country' |translate |translateKey}}&nbsp; </th>
                            <th (click)="sortTableByColumn('rowStatusId')" class="pointer">
                                {{'config-system.Status' |translate |translateKey}}&nbsp;
                                <i class="fa"
                                    [ngClass]="{'fa-sort': sortColumn != 'rowStatusId', 'fa-sort-asc': (sortColumn == 'rowStatusId' && isDesc), 'fa-sort-desc': (sortColumn == 'rowStatusId' && !isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let refundReasons of reasons | paginate: { id:'refund-cancel-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                            <td>
                                <ng-container *ngIf="refundReasons.hasAccess;else deny">
                                    <a (click)="editReasoneForm(refundReasons.id)">{{refundReasons.reasonNote}}</a>
                                </ng-container>
                                <ng-template #deny>
                                    {{refundReasons.reasonNote}}
                                </ng-template>
                            </td>
                            <td>{{refundReasons.countryname}}</td>
                            <td>{{refundReasons.status}}</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="pageCount===0">
                        <tr align="center">
                            <td colspan="3">{{'ticketing-system.No records found.' |translate |translateKey}}</td>
                        </tr>
                    </tbody>
                </table>
                {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
                <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </section>
    </div>
</div>


<!-- popup for addnew Reasons -->
<modal #createReasonsModal class="createTicketModal-header">
    <modal-header>
        <div class="color-blue">
            {{(isUpdate) ? ('config-system.MANAGE CANCEL/REFUND REASON' |translate  |translateKey ):('config-system.ADD NEW CANCEL/REFUND REASON' |translate |translateKey) }}
        </div>
    </modal-header>
    <modal-content>
        <form *ngIf="reasonsForm" [formGroup]="reasonsForm" (ngSubmit)="onSubmit(reasonsForm.valid)"
            style="margin-left: -15px;width: 104%;" class="col-xs-12 ticket-color-validation" novalidate>
            <div class="row no-margin">
                <div class="row form-horizontal">
                    <label for="operatingCountryId"
                        class="col-sm-3 col-form-label">{{'config-system.Operating Country' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input">
                        <select autofocus tabindex="0" id="autofocus-modal-element"
                            class="form-control ng-pristine ng-invalid ng-touched" formControlName="operatingCountryId"
                            [attr.disabled]="!isUpdate?null:''">
                            <option *ngIf="isCountriesLoading" value="">
                                {{'department-system.Loading...' |translate |translateKey}}</option>
                            <option value="">{{'config-system.--Select--' |translate |translateKey}}</option>
                            <option *ngFor="let country of modalOperatingCountry | orderBy:'name'" [value]="country.id">
                                {{country.name}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!reasonsForm.controls['operatingCountryId'].valid  && reasonsForm.controls['operatingCountryId'].hasError('required') && (reasonsForm.controls['operatingCountryId'].touched || isSubmitted)">
                            {{'validation-message.Operating Country is required'|translate |translateKey}}
                        </div>
                    </div>
                </div>
                <div class="row clearboth">
                    <label for="reasons"
                        class="col-sm-3 col-form-label">{{'config-system.Reason' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input ">
                        <input id="reasonsInput-focus" tabindex="0" type="text" class="form-control pl-5"
                            formControlName="reasons" placeholder="{{'config-system.Cancel/Refund Reason' |translate}}">
                        <div class="alert-msg"
                            *ngIf="(!reasonsForm.controls['reasons'].valid  && reasonsForm.controls['reasons'].hasError('required') && 
                            (reasonsForm.controls['reasons'].touched || isSubmitted  )) || reasonsForm.get('reasons')?.hasError('noEmptyString') ">
                            {{'validation-message.Reason is required'|translate |translateKey}}
                        </div>
                    </div>
                </div>
                <div class="row clearboth">
                    <label for="reasonStatus" class="col-sm-3 col-form-label">&nbsp;</label>
                    <div class="col-sm-6 ">
                        <input tabindex="0" type="checkbox" id="status" formControlName="reasonStatus" />
                        <label>{{'config-system.Active' |translate |translateKey}}</label>
                    </div>
                </div>
            </div>
            <div class=" row pull-right pad-r-8 label_add_another">
                <div class="col-6" *ngIf="!isUpdate">
                    <input tabindex="0" type="checkbox" id="status" formControlName="addAnother" />
                    <label>{{'config-system.Add another' |translate |translateKey}}</label>
                </div>
                <div class="col-6">
                    <button tabindex="0" [disabled]="!reasonsForm.valid" class="btn btn-add blue-button" type="submit">
                        {{ (isUpdate) ? ('config-system.UPDATE' |translate |translateKey) : ('config-system.Add' |translate |translateKey) }}
                    </button>
                    <button tabindex="0" class="btn btn-add grey-button" type="button" (click)="closePopUp()"
                        data-dismiss="modal" aria-label="Close">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </div>
        </form>
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/configuration/order-status-change-reason.component.html